import { FormCheckbox, FormDatePicker, FormInput, FormRichTextEditor, FormSectionHeader, FormSelect, FormTextarea, Heading, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import { AUDIT_SCOPE, auditScopeOptions, CONTENT, DESCRIPTION, EFFECTIVE_DATE, INCLUDE_STATE_LAW, LICENSE_CATEGORY, licenseCategoryOptions, STATE, TEMPLATE_NAME, VERSION_NO } from "./consts";
import { Button } from "@/components/ui";
import { stateLawStatus } from "@/lib/utils";

const AddEdit = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
    stateList,
    isStateLawDataLoading,
    isView,
    isUpdatePending,
    id,
    isAddResponse,
    isStateLoading,
    stateLawData
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title={breadcrumbData[breadcrumbData.length - 1].name}
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      {isStateLawDataLoading || isStateLoading ? <Loader /> : <FormProvider {...form}>
        <form>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
              <FormSelect
                name={STATE}
                control={form.control}
                label="State"
                placeholder="Please enter"
                error={errors[STATE]?.message}
                isRequired={requiredFields.includes(STATE)}
                options={stateList?.data?.map((data: any) => ({
                  label: data.stateName,
                  value: data.stateCode?.toString(),
                }))}
                disabled={isView}
              />
              <FormSelect
                name={LICENSE_CATEGORY}
                control={form.control}
                label="License Category"
                placeholder="Please enter"
                error={errors[LICENSE_CATEGORY]?.message}
                isRequired={requiredFields.includes(LICENSE_CATEGORY)}
                options={licenseCategoryOptions}
                disabled={isView}
              />
              <FormSelect
                name={AUDIT_SCOPE}
                control={form.control}
                label="Audit Scope"
                placeholder="Please enter"
                error={errors[AUDIT_SCOPE]?.message}
                isRequired={requiredFields.includes(AUDIT_SCOPE)}
                options={auditScopeOptions}
                disabled={isView}
              />
              <div>
                <FormDatePicker
                  name={EFFECTIVE_DATE}
                  control={form.control}
                  label="Effective Date"
                  placeholder="Please enter"
                  error={errors[EFFECTIVE_DATE]?.message}
                  isRequired={requiredFields.includes(EFFECTIVE_DATE)}
                  disabled={isView}
                />
              </div>
              <FormTextarea
                name={DESCRIPTION}
                control={form.control}
                label="Description"
                placeholder="Please enter"
                error={errors[DESCRIPTION]?.message}
                isRequired={requiredFields.includes(DESCRIPTION)}
                disabled={isView}
              />
              <div>
                <FormCheckbox
                  name={INCLUDE_STATE_LAW}
                  control={form.control}
                  label="Include State Law"
                  placeholder="Please enter"
                  error={errors[INCLUDE_STATE_LAW]?.message}
                  isRequired={requiredFields.includes(INCLUDE_STATE_LAW)}
                  disabled={isView}
                />
              </div>
              
              {(!id && form.watch(TEMPLATE_NAME) || isView) ? <FormInput
                name={TEMPLATE_NAME}
                control={form.control}
                label="Template Name"
                placeholder="Please enter"
                error={errors[TEMPLATE_NAME]?.message}
                isRequired={requiredFields.includes(TEMPLATE_NAME)}
                disabled={isView}
              /> : <></>}
              {(!id && form.watch(TEMPLATE_NAME) || isView) ? <FormInput
                name={VERSION_NO}
                control={form.control}
                label="Version No"
                placeholder="Please enter"
                error={errors[VERSION_NO]?.message}
                isRequired={requiredFields.includes(VERSION_NO)}
                disabled={isView}
              /> : <></>}
            </div>
          </div>

          {form.watch(CONTENT) ? <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <FormSectionHeader>{form.watch(TEMPLATE_NAME) || ""}</FormSectionHeader>
            <div className="grid grid-cols-1 gap-[30px] w-full">
              <FormRichTextEditor 
                name={CONTENT}
                control={form.control}
                placeholder="Please enter"
                error={errors[CONTENT]?.message}
                isRequired={requiredFields.includes(CONTENT)} 
                disabled={isView}
              />
            </div>
          </div> : <></>}
          <div className="flex flex-row justify-end gap-3 py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending || isUpdatePending}
            >
              Cancel
            </Button>

            {isView ? stateLawData?.data?.status == stateLawStatus.draft.value ? <Button type="submit" disabled={isAddPending || isUpdatePending} 
              onClick={() => {
                form.handleSubmit((data) => {
                  onSubmit(data, stateLawStatus.published.value);
                })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Publish
            </Button> : <></> : isAddResponse ? <>
            <Button type="button" disabled={isAddPending || isUpdatePending} 
              onClick={() => {
                form.handleSubmit((data) => {
                  onSubmit(data, stateLawStatus.draft.value);
                })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Draft
            </Button>
            <Button type="submit" disabled={isAddPending || isUpdatePending} 
              onClick={() => {
                form.handleSubmit((data) => {
                  onSubmit(data, stateLawStatus.published.value);
                })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Publish
            </Button>
            </> : <Button type="button" disabled={isAddPending || isUpdatePending} 
              onClick={() => {
                form.handleSubmit((data) => {
                  onSubmit(data, "GENERATE");
                })();
            }}>
              {isAddPending || isUpdatePending && <Loader variant="secondary" />}
              Generate
            </Button>}
          </div>
        </form>
      </FormProvider>}
    </div>
  );
};

export default AddEdit;
